import axios from '../../../../../api/ai-axios';

/**
 * 语音合成API
 * @param {Object} data 请求参数
 * @param {string} data.text 要合成的文本
 * @param {string} data.voice 使用的音色
 * @param {string} data.language_type 合成音频的语种
 * @param {string} data.model 模型名称，默认qwen3-tts-flash
 * @returns {Promise} 返回音频URL和相关信息
 */
export const textToSpeech = (data) => {
  const formData = new FormData();

  formData.append('model', data.model || 'qwen3-tts-flash');
  formData.append('text', data.text);
  formData.append('voice', data.voice);
  formData.append('language_type', data.language_type || 'Auto');

  return axios.post('/api/qwen_tts', formData);
};

/**
 * 下载音频文件
 * @param {string} audioUrl 音频URL
 * @returns {Promise<Blob>} 返回音频Blob对象
 */
export const downloadAudio = async (audioUrl) => {
  try {
    const response = await fetch(audioUrl);
    if (!response.ok) {
      throw new Error(`下载失败: ${response.status} ${response.statusText}`);
    }
    return await response.blob();
  } catch (error) {
    console.error('音频下载失败:', error);
    throw error;
  }
};

/**
 * 将Blob转换为可播放的URL
 * @param {Blob} blob 音频Blob对象
 * @returns {string} 可播放的Blob URL
 */
export const createAudioUrl = (blob) => {
  return URL.createObjectURL(blob);
};

/**
 * 清理音频Blob URL
 * @param {string} blobUrl Blob URL
 */
export const revokeAudioUrl = (blobUrl) => {
  if (blobUrl && blobUrl.startsWith('blob:')) {
    URL.revokeObjectURL(blobUrl);
  }
};
